// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-app-auth-helper-redirect-js": () => import("/var/fleet_tracker/app/src/pages/appAuthHelperRedirect.js" /* webpackChunkName: "component---src-pages-app-auth-helper-redirect-js" */),
  "component---src-pages-index-js": () => import("/var/fleet_tracker/app/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/var/fleet_tracker/app/.cache/data.json")

